import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
// pk模式的store
var localRobot = JSON.parse(localStorage.getItem('robot')) || {
  nickname: '',
  avatar: ''
};
var state = function state() {
  return {
    robot: {
      nickname: localRobot.nickname,
      avatar: localRobot.avatar
    }
  };
};
var mutations = {
  setRobot: function setRobot(state, payload) {
    state.robot.nickname = payload.nickname;
    state.robot.avatar = payload.avatar;

    // 本地化存储
    localStorage.setItem('robot', JSON.stringify(state.robot));
  }
};
var getters = {
  getRobot: function getRobot(state, rootState) {
    return state.robot;
  }
};
export default {
  state: state,
  mutations: mutations,
  getters: getters
};